import React, { useState, useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_substage_wizard/EditSubstageForm.scss';
import Button from '../../components/Button';
import Select from '../../components/Select';
import Input from '../../components/Input';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import ButtonGroup from '../../components/ButtonGroup';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import * as _ from 'lodash';
import { listPossibleStages } from '../../redux/actions/table/substages';
import DateTimePicker from '../../components/DateTimePicker';
import Tooltip from '../../components/Tooltip';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';

const EditSubstageForm = ({
  localization,
  handleSubmit,
  onSubmit,
  submitting,
  application_language_id,
  match,
}) => {
  const [possibleStages, setPossibleStages] = useState([]);

  const _handleSubmit = (create_and_edit) => {
    return handleSubmit((formData) => {
      return onSubmit({
        ...formData,
        edit: create_and_edit,
      });
    })();
  };

  const application_languages = _.transform(
    _.filter(
      localization.languages,
      (language) => language.application_language == true
    ),
    (languages, language) => {
      languages[language.id] = language.id == application_language_id;
      return languages;
    },
    {}
  );

  useEffect(() => {
    const project_id = match.params.project;

    listPossibleStages(project_id).then(({ response }) => {
      setPossibleStages(response.data);
    });
  }, []);

  const statuses = [
    { label: __('substage.status.started'), value: '0', color: '#5777FC' },
    { label: __('substage.status.finished'), value: '1', color: '#ADD42B' },
  ];

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('substage.status')}
              options={statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('substage.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div>

        <Field
          name='name'
          localized={application_languages}
          component={Input}
          label={__('substage.name')}
        />
        <div className={styles.flex}>
          <div className={styles.f3}>
            <Field
              name='date'
              component={DateTimePicker}
              label={__('substage.date')}
              footer
              range
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='duration'
              component={Input}
              label={__('substage.duration')}
            />
          </div>
        </div>
        <Field
          name='stage_id'
          component={Select}
          label={__('substage.stage')}
          options={possibleStages}
        />
        <Field
          name='description'
          component={Input}
          label={__('substage.description')}
        />
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('substages', {
              edit_substage_wizard: undefined,
            })
          }
        />
        <ButtonGroup>
          <Button
            lightBlue
            medium
            middleText={__('button.create')}
            spinning={submitting}
            onClick={() => _handleSubmit(false)}
          />
        </ButtonGroup>
      </div>
    </Form>
  );
};

export default withRouter(
  reduxForm({ form: 'edit_substage_wizard.edit_substage' })(
    subscribe(
      Localization,
      'localization'
    )(
      mapStateToProps((state) => ({
        application_language_id: state.auth.language_id,
      }))(EditSubstageForm)
    )
  )
);
